export default __webpack_public_path__ + "images/SpeakersPhotos/José Luis Alonso Gallardo.jpg?c919e401";